<template>
  <div class="page2">
    <div class="srcoll" style="padding-top: 5px;">
      <section class="section" style="padding-top: 0;">
        <div class="z-title">观察对象 <span>*</span></div>
        <div class="content">
          <a-space style="width: 100%;flex-wrap: wrap;">
            <a-button
              v-for="(item, index) in students"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item.name }} <a-icon style="color: #999;" type="lock"
            /></a-button>
            <!-- <a-button shape="round" size="small" @click="showAddStudents = true"
              ><a-icon type="plus" />添加/选择学生</a-button
            > -->
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">关联领域</div>
        <div class="content">
          <a-space style="width: 100%;flex-wrap: wrap;">
            <a-button
              @click="range.splice(index, 1)"
              v-for="(item, index) in range"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="showRange = true"
              ><a-icon type="plus" />添加/选择关联领域</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">发展阶段</div>
        <bea-list
          :list="beas"
          @del="handleDelBea"
          @edit="handleEditbeva(item)"
          labelPos="block"
          backgroundColor="#fff"
          :showAction="false"
        ></bea-list>
        <div
          class="content"
          :style="{ marginTop: beas.length ? '0px' : '20px' }"
        >
          <a-space>
            <a-button
              @click="form.level.splice(index, 1)"
              v-for="(item, index) in form.level"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <!-- <a-button shape="round" size="small" @click="handleAddbeva"
              ><a-icon type="plus" />添加行为表现</a-button
            > -->
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">记录时间 <span>*</span></div>
        <div class="content">
          <a-date-picker
            show-time
            @change="onChangeDate"
            v-model="form.record_time"
          />
        </div>
      </section>

      <!-- <section class="section" style="border-bottom: none;">
        <div class="z-title">同步给家长 <span>*</span></div>
        <div class="content">
          <a-radio-group v-model="form.sync_parent">
            <a-radio :value="0">
              不同步
            </a-radio>
            <a-radio :value="1">
              同步
            </a-radio>
          </a-radio-group>
        </div>
      </section> -->

      <a-modal
        width="720px"
        :visible="showRange"
        @cancel="showRange = false"
        @ok="handleAddRange"
        title="选择领域"
        :bodyStyle="{ padding: '10px 20px' }"
        centered
      >
        <div v-for="(item, index) in rangeList" :key="index" class="range">
          <div class="Up">{{ item.name }}</div>
          <a-checkbox-group v-model="rangeCheckedList[index]">
            <a-row>
              <a-col
                v-for="(range, index2) in item.childs"
                :key="index2"
                :span="6"
              >
                <a-checkbox :value="range.name">
                  {{ range.name }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
      </a-modal>
    </div>

    <a-modal
      :visible="showAddCj"
      width="780px"
      @cancel="showAddCj = false"
      :bodyStyle="{ padding: '10px 20px' }"
      @ok="handleAddCj"
      title="选择对应观察场景"
      centered
    >
      <div v-for="(item, index) in cjList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-checkbox-group v-model="cjCheckedList[index]">
          <a-row>
            <a-col
              v-for="(child, index2) in item.scenes"
              :key="index2"
              :span="8"
            >
              <a-checkbox :value="child.name">
                {{ child.name }}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
      <div class="range">
        <div class="Up">其他</div>
        <a-checkbox-group v-model="selef_scene_ids">
          <a-row>
            <a-col v-for="child in selef_scenes" :key="child.id" :span="8">
              <a-checkbox :value="child.name">
                {{ child.name }}
              </a-checkbox>
              <a-icon
                @click="handleDelSelef('scene', child.id)"
                style="margin-left: 10px;color: #999;font-size: 13px;flex: 1;cursor: pointer;"
                type="delete"
              ></a-icon>
            </a-col>
            <a-col :span="8">
              <a-button
                type="default"
                size="small"
                shap="round"
                ghost
                style="color: #999;margin-top: 2px"
                @click="handleAddSelef('scene')"
                >+自定义</a-button
              >
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
    </a-modal>

    <a-modal
      :visible="showSelef"
      @ok="handleAddSelefOk"
      title="添加自定义"
      width="480px"
      :z-index="3999"
      @cancel="showSelef = false"
      :bodyStyle="{ padding: '30px 20px' }"
      centered
    >
      <div>
        <a-input v-model="selef_name" placeholder="请输入自定义名称"></a-input>
      </div>
    </a-modal>

    <a-modal
      :visible="showActivity"
      @cancel="showActivity = false"
      @ok="handleAddActivity"
      title="选择关联活动"
      width="720px"
      :bodyStyle="{ padding: '10px 20px' }"
      centered
    >
      <div v-for="(item, index) in activityList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-checkbox-group v-model="activityCheckedList[index]">
          <a-row>
            <a-col v-for="(act, index2) in item.acts" :key="index2" :span="6">
              <a-checkbox :value="act.name">
                {{ act.name }}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
      <div class="range">
        <div class="Up">其他</div>
        <a-checkbox-group v-model="selef_act_ids">
          <a-row>
            <a-col v-for="child in selef_acts" :key="child.id" :span="6">
              <a-checkbox :value="child.name">
                {{ child.name }}
              </a-checkbox>
              <a-icon
                @click="handleDelSelef('act', child.id)"
                style="margin-left: 10px;color: #999;font-size: 13px;flex: 1;cursor: pointer;"
                type="delete"
              ></a-icon>
            </a-col>
            <a-col :span="6">
              <a-button
                type="default"
                size="small"
                shap="round"
                ghost
                style="color: #999;margin-top: 2px"
                @click="handleAddSelef('act')"
                >+自定义</a-button
              >
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
    </a-modal>

    <a-modal
      :visible="showRange"
      @cancel="showRange = false"
      @ok="handleAddRange"
      title="选择领域"
      centered
      width="720px"
      :bodyStyle="{ padding: '10px 20px' }"
    >
      <div v-for="(item, index) in rangeList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-checkbox-group v-model="rangeCheckedList[index]">
          <a-row>
            <a-col
              v-for="(range, index2) in item.childs"
              :key="index2"
              :span="6"
            >
              <a-checkbox :value="range.name">
                {{ range.name }}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
    </a-modal>

    <a-modal
      width="720px"
      :visible="showAddStudents"
      @cancel="showAddStudents = false"
      @ok="handleAddStudents"
      title="选择孩子"
      :bodyStyle="{ padding: '10px 20px' }"
      centered
    >
      <!-- <a-row>
        <a-checkbox :checked="checkAll" @change="handleSelectAllStudents">
          全部
        </a-checkbox>
      </a-row> -->
      <div style="font-size: 12px;color: #999;">
        *灰色学生暂未提交,不能转换快速记
      </div>
      <div v-for="(item, index) in studentList" :key="index" class="range">
        <div class="Up">{{ item.group_name }}</div>
        <!-- <a-checkbox-group @change="handleCancelAllStudents"> -->
        <a-row>
          <a-col
            v-for="(child, index2) in item.student"
            :key="index2"
            :span="6"
          >
            <a-checkbox
              @change="handleChangeSelectChild(child)"
              :checked="child.checked"
              :value="child.id"
              :disabled="child.disabled"
            >
              {{ child.name }}
            </a-checkbox>
          </a-col>
        </a-row>
        <!-- </a-checkbox-group> -->
      </div>
    </a-modal>

    <a-modal
      :visible="showBea"
      @cancel="showBea = false"
      @ok="handleAddBea"
      title="选择表现行为"
      centered
      width="720px"
      :bodyStyle="{ padding: '10px 20px' }"
    >
      <div v-for="(item, index) in rangeList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-radio-group
          v-model="bea"
          name="bea"
          @change="handleChangeBea($event, item)"
          style="width: 100%;"
        >
          <a-row style="position: relative;">
            <a-col
              v-for="(child, index2) in item.childs"
              :key="index2"
              :span="6"
            >
              <a-radio
                :class="bea == child.name ? 'select-this' : ''"
                :value="child.name"
              >
                {{ child.name }}
              </a-radio>

              <div
                class="select"
                v-if="bea == child.name"
                style="width: 680px;overflow: hidden;padding: 5px 0;padding-top: 6px;border-top: 1px solid #6fb0dc;font-size: 12px;margin-top: 14px"
                :style="{ marginLeft: -(index2 / 4) * 680 + 'px' }"
              >
                <a-radio-group
                  @change="handleSelectBea2($event, child)"
                  style="width: 680px;"
                  name="bea2"
                >
                  <a-row>
                    <a-radio
                      v-for="(child2, index3) in child.childs"
                      :key="index3"
                      name="bea2"
                      style="font-size: 12px;color: #67b0dc"
                      @change="handleSelectBea3($event, child2)"
                      :value="child2.name"
                    >
                      {{ child2.name }}
                    </a-radio>
                  </a-row>
                </a-radio-group>
              </div>
            </a-col>
          </a-row>
        </a-radio-group>
      </div>
    </a-modal>
    <a-modal
      :visible="previewModal"
      @cancel="previewModal = false"
      centered
      title="预览"
      :footer="false"
      :closeable="false"
      :bodyStyle="{ padding: '20px 20px' }"
    >
      <div class="preview-body">
        <img
          style="width: 100%;height: auto"
          v-if="previewUrl.type == 'pic'"
          :src="previewUrl.url"
        />
        <video
          v-if="previewUrl.type == 'video'"
          style="width: 100%;height: 300px;object-fit: fill;"
          :src="previewUrl.url"
          controls
        ></video>
        <audio
          style="width: 100%;object-fit: fill;"
          v-if="previewUrl.type == 'record'"
          :src="previewUrl.url"
          controls
        ></audio>
      </div>
    </a-modal>

    <add-level
      :show="openBea"
      @add="handleConfirmAddBea"
      :data="selectBeaForm"
      @close="openBea = false"
    ></add-level>
  </div>
</template>

<script>
import axios from "axios";
import beaList from "@/components/bea-list-add.vue";
import { mapActions } from "vuex";
import qs from "qs";
import _ from "lodash";
import addLevel from "@/pages/observe/add-level.vue";
import { directorTestApi } from "@/api/api-director";
import { mapState } from "vuex";
import moment from "moment";
import { groupBy } from "lodash";

export default {
  data() {
    return {
      saveTime: "",
      data: null,
      selef_act_ids: [],
      selef_scene_ids: [],
      selef_scenes: [],
      selef_acts: [],
      previewUrl: "",
      previewModal: false,
      directorTestApi,
      bea: "",
      showBea: false,
      checkAll: false,
      showPlate: false,
      showPush: "",
      analysis_att1: [],
      analysis_att2: [],
      guidance_att1: [],
      guidance_att2: [],
      strategy_att1: [],
      selectBeaForm: null,
      cj: [],
      strategy_att2: [],
      record_att: [
        {
          record_text: "",
          fileList: [],
          fileList2: [],
        },
      ],
      form: {
        type: 1,
        content: "",
        record_time: null,
        strategy: "",
        act_id: "",
        record_att: [
          {
            record_text: "",
            fileList: [],
            fileList2: [],
          },
        ],
        analysis: "",
        guidance: "",
        range: [],
        status: 1,
        sync_parent: 0,
      },
      students: [],
      selectType: 2,
      loading: false,
      fileList: [],
      fileList2: [],
      showAddStudents: false,
      showAddCj: false,
      activeCl: null,
      studentList: [],
      checkedList: [],
      showRange: false,
      rangeCheckedList: [],
      active: 0,
      rangeList: [],
      range: [],
      activity: [],
      activityList: [],
      showActivity: false,
      activityCheckedList: [],
      cjCheckedList: [],
      cjList: [
        {
          label: "生活",
          childs: [
            "来离园活动",
            "餐点活动",
            "饮水活动",
            "如厕盥洗活动",
            "午睡",
            "户外散步",
          ],
        },
        {
          label: "游戏",
          childs: ["角色游戏", "表演游戏", "结构游戏", "自由活动"],
        },
        {
          label: "学习",
          childs: [
            "集体教学",
            "益智区",
            "生活区",
            "语言区",
            "科学探索",
            "美工区",
            "音乐区",
          ],
        },
      ],
      SelectBea: null,
      customStyle:
        "background: #fff;border-radius: 4px;border: 0;overflow: hidden;font-weight:bold",
      activeKey: 0,
      showClDetail: false,
      clList: [],
      guideList: [],
      uploadLoading: {
        guidance_att1: false,
        guidance_att2: false,
        analysis_att1: false,
        analysis_att2: false,
        observe_att1: false,
        observe_att2: false,
        reback_cl_att1: false,
        reback_cl_att2: false,
      },
      openBea: false,
      beaSelect: null,
      beas: [],
      targets: [],
      showSelef: false,
      selefType: "scene",
      selef_name: "",
      gradeList: [],
      currentPageClass: {
        name: "",
      },
      selectNum2: 0,
    };
  },

  components: {
    beaList,
    addLevel,
  },
  computed: {
    ...mapState(["currentClass", "userInfo"]),
    selectNum() {
      let num = 0;
      if (this.showPush == "cl") {
        this.clList.forEach((child) => {
          child.childs.forEach((item) => {
            item.childs.forEach((detail) => {
              if (detail.detail_id) {
                num += detail.detail_id.length;
              }
            });
          });
        });
      }
      return num;
    },
    formContent() {
      if (
        this.form.record_time ||
        this.form.analysis ||
        this.form.student_id ||
        this.beas.length
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.getDetail();
        this.getGradeList();
        if (this.currentClass) {
          // this.getAllStudents();
        } else {
          this.getClassList();
        }
        this.init();
      }
    },
    showAddStudents(val) {
      if (val) {
        const students = this.students.map((item) => {
          return item.id;
        });
        const pushids = this.pushStudents.map((item) => {
          return item.id;
        });
        this.studentList.forEach((group, index) => {
          group.student.forEach((item) => {
            if (pushids.includes(item.id)) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
            if (students.includes(item.id)) {
              item.checked = true;
            }
          });
        });
      }
    },
    showRange(val) {
      if (val) {
        if (this.rangeList.length) {
          this.rangeList.forEach((group, index) => {
            this.rangeCheckedList[index] = [];
            group.childs.forEach((item) => {
              if (this.range.includes(item.name)) {
                this.rangeCheckedList[index].push(item.name);
              }
            });
          });
          this.$forceUpdate();
        } else {
          this.$message.info("领域加载中，如未更新状态，请重试");
          setTimeout(() => {
            this.rangeList.forEach((group, index) => {
              this.rangeCheckedList[index] = [];
              group.childs.forEach((item) => {
                if (this.range.includes(item.name)) {
                  this.rangeCheckedList[index].push(item.name);
                }
              });
            });
            this.$forceUpdate();
          }, 2000);
        }
      }
    },
    showActivity(val) {
      if (val) {
        if (this.activityList.length) {
          this.activityList.forEach((group, index) => {
            this.activityCheckedList[index] = [];
            group.acts.forEach((item) => {
              if (this.activity.includes(item.name)) {
                this.activityCheckedList[index].push(item.name);
              }
            });
          });
          this.$forceUpdate();
        } else {
          this.$message.info("活动加载中，如未更新状态，请重试");
          setTimeout(() => {
            this.activityList.forEach((group, index) => {
              this.activityCheckedList[index] = [];
              group.acts.forEach((item) => {
                if (this.activity.includes(item.name)) {
                  this.activityCheckedList[index].push(item.name);
                }
              });
            });
            this.$forceUpdate();
          }, 2000);
        }
      }
    },
    showAddCj(val) {
      if (val) {
        if (this.cjList.length) {
          this.cjList.forEach((group, index) => {
            this.cjCheckedList[index] = [];
            group.scenes.forEach((item) => {
              if (this.cj.includes(item.name)) {
                this.cjCheckedList[index].push(item.name);
              }
            });
          });
          this.$forceUpdate();
        } else {
          this.$message.info("场景加载中，如未更新状态，请重试");
          setTimeout(() => {
            this.cjList.forEach((group, index) => {
              this.cjCheckedList[index] = [];
              group.childs.forEach((item) => {
                if (this.cj.includes(item.name)) {
                  this.cjCheckedList[index].push(item.name);
                }
              });
            });
            this.$forceUpdate();
          }, 2000);
        }
      }
    },
    userInfo() {
      if (this.userInfo) {
        if (this.currentClass) {
          // this.getAllStudents();
        } else {
          this.getClassList();
        }
        this.init();

        if (this.id) {
          this.getDetail();
        }
      }
    },
    // form() {
    //   if (
    //     this.$route.query.id &&
    //     this.cjList.length &&
    //     this.activityList.length &&
    //     this.rangeList.length
    //   ) {
    //     _.debounce(this.handlePush("draft"), 10000);
    //   }
    // },
    showPush(newV) {
      if (newV) {
        this.getRebackList();
        this.getGuideList();
      }
    },
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  beforeDestroy() {
    if (this.saveTimer) {
      clearInterval(this.saveTimer);
    }
  },
  created() {
    this.getDetail();
    this.getGradeList();
    if (this.currentClass) {
      // this.getAllStudents();
    } else {
      this.getClassList();
    }
    this.init();
  },
  methods: {
    handleChangeClass(item) {
      this.currentPageClass = item;
      if (this.showPush == "cl") {
        this.getRebackList();
      } else {
        this.getGuideList();
      }
    },
    getGradeList() {
      axios({
        url: directorTestApi.main + directorTestApi.getSchoolGradeList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        method: "post",
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.gradeList = res.data.data;
          this.currentPageClass = this.gradeList[0];
        }
      });
    },
    getDetail() {
      if (!this.id) return;
      this.$message.loading({
        content: "正在获取详情...",
        key: "loading",
      });
      axios({
        url: directorTestApi.main + directorTestApi.getObserTaskDetail,
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          id: this.id,
          teacher_id: this.userInfo.id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "获取成功",
            key: "loading",
            duration: 0.5,
          });
          const data = res.data.data;
          this.data = res.data.data;

          this.form = {
            id: data.id,
            type: 1,
            record_time: moment(data.record_time).format("YYYY-MM-DD HH:mm:ss"),
            strategy: data.strategy,
            act_id: "",
            record_att: [
              {
                record_text: "",
                fileList: [],
                fileList2: [],
              },
            ],
            teacher_name: data.teacher_name,
            analysis: data.analysis,
            guidance: data.guidance,
            range: [],
            status: 1,
            sync_parent: data.sync_parent ? 1 : 0,
          };
          this.students = data.students.filter((arr) => arr.obser_circle_id && arr.trans_notable_status == '未转');
          this.pushStudents = data.students.filter(
            (arr) => arr.obser_circle_id
          );
          this.studentList = [
            {
              group_name: "任务学生",
              student: [...data.students],
            },
          ];
          // this.record_att = [
          //   {
          //     record_text: data.record_text,
          //     fileList: data.att
          //       .filter((item) => item.type != "record")
          //       .map((item, index) => {
          //         item.response = { data: _.cloneDeep(item) };
          //         item.thumbUrl =
          //           item.type == "video"
          //             ? require("../../assets/director/video.png")
          //             : item.url;
          //         item.status = "done";
          //         item.uid = item.id;
          //         item.name = "record" + index;
          //         item.response.data.id = item.accessory_id;
          //         return item;
          //       }),
          //     fileList2: data.att
          //       .filter((item) => item.type == "record")
          //       .map((item, index) => {
          //         item.thumbUrl = require("../../assets/director/record.png");
          //         item.status = "done";
          //         item.response = { data: _.cloneDeep(item) };
          //         item.uid = item.id;
          //         item.name = "audio" + index;
          //         item.response.data.id = item.accessory_id;
          //         return item;
          //       }),
          //   },
          // ];

          this.range = data.fields.map((item) => item.target_name);
          const student_ids = this.students.map((item) => item.id);
          this.beas = data.target2.filter((item) => student_ids.includes(item.id));
          this.showModal = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleRemove() {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: "提示",
          content: "确定要删除吗？",
          centered: true,
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            resolve(true);
          },
          onCancel() {
            resolve(false);
          },
        });
      });
    },
    handleDelSelef(type, id) {
      axios({
        url:
          type == "scene"
            ? directorTestApi.main + directorTestApi.saveDeleteObserSelfScene
            : directorTestApi.main + directorTestApi.saveDeleteObserSelfAct,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          teacher_id: this.userInfo.id,
          id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "删除成功",
          });
          if (type == "scene") {
            this.getSelefScenes();
          } else {
            this.getSelefActs();
          }
        } else {
          this.$message.error({ content: res.data.message });
        }
      });
    },
    handleAddSelef(type) {
      this.selefType = type;
      this.showSelef = true;
    },
    handleAddSelefOk() {
      this.$message.loading({
        content: "正在添加...",
        key: "addSelef",
      });
      axios({
        url:
          this.selefType == "scene"
            ? directorTestApi.main + directorTestApi.saveObserSelfScene
            : directorTestApi.main + directorTestApi.saveObserSelfAct,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          teacher_id: this.userInfo.id,
          name: this.selef_name,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "添加成功",
            key: "addSelef",
          });
          this.selefType == "scene"
            ? this.getSelefScenes()
            : this.getSelefActs();
          this.showSelef = false;
          this.selef_name = "";
        } else {
          this.$message.error({ content: res.data.message, key: "addSelef" });
        }
      });
    },
    getSelefScenes() {
      axios({
        url: directorTestApi.main + directorTestApi.getObserSelfSceneList,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
          teacher_id: this.userInfo.id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.selef_scenes = res.data.data;
          this.selef_scene_ids = this.selef_scene_ids.filter((name) => {
            if (this.selef_scenes.map((item) => item.name).includes(name)) {
              return true;
            } else {
              return false;
            }
          });
        } else {
          this.selef_scenes = [];
        }
      });
    },
    getSelefActs() {
      axios({
        url: directorTestApi.main + directorTestApi.getObserSelfActList,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
          teacher_id: this.userInfo.id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.selef_acts = res.data.data;
          this.selef_act_ids = this.selef_act_ids.filter((name) => {
            if (this.selef_acts.map((item) => item.name).includes(name)) {
              return true;
            } else {
              return false;
            }
          });
        } else {
          this.selef_acts = [];
        }
      });
    },
    handleDelBea(index, index2) {
      console.log(index, index2);
      this.beas[index].targets.splice(index2, 1);
      this.$forceUpdate();
    },
    handleConfirmAddBea(list) {
      list.forEach((item) => {
        if (this.beas.map((item2) => item2.id).includes(item.id)) {
          this.beas.forEach((detail) => {
            if (detail.id == item.id) {
              //学生id重复
              item.targets.forEach((target1) => {
                if (
                  detail.targets.map((item3) => item3.id).includes(target1.id)
                ) {
                  // 一级二级重复
                  //根据id判断item.targets.targets和detail.targets.targets下面列表是否重复,重复只保留一个
                  target1.targets.forEach((target2) => {
                    const detail2 = detail.targets.find(
                      (item4) => item4.id == target1.id
                    );
                    const ids = detail2.targets.map((item3) => item3.id);
                    if (ids.includes(target2.id)) {
                    } else {
                      detail2.targets.push(target2);
                    }
                  });
                } else {
                  detail.targets.push(target1);
                }
              });
            }
          });
        } else {
          this.beas.push(item);
        }
      });
      console.log(this.beas);
      this.openBea = false;
    },
    handleChangeSelectChild(child) {
      child.checked = !child.checked;
      this.$forceUpdate();
    },
    handleChangeGuide(child) {
      child.checked = !child.checked;
      let num = 0;

      this.guideList.forEach((child) => {
        child.childs.forEach((item) => {
          item.childs.forEach((detail) => {
            if (detail.checked) {
              num++;
            }
          });
        });
      });

      this.selectNum2 = num;
      this.$forceUpdate();
    },
    onChangeDate(e, date) {
      console.log(e, date);
      this.form.record_time = date;
    },
    handlePreview(e) {
      console.log(e);
      this.previewUrl = {
        url: e.response.data.url,
        type: this.getFileType(e.response.data.url),
      };
      this.previewModal = true;
    },
    getFileType(url) {
      //根据资源路径后缀判断资源类型
      const type = url.split(".").pop();
      if (type == "mp4" || type == "avi" || type == "mov") {
        return "video";
      }

      if (type == "jpg" || type == "png" || type == "jpeg") {
        return "pic";
      }

      if (type == "mp3" || type == "wav" || type == "aac" || type == "ogg") {
        return "record";
      }
    },
    init() {
      this.getActList();
      this.getSceneList();
      this.getRangeList();
      this.getSelefActs();
      this.getSelefScenes();
    },
    getSceneList() {
      const form = {
        currentPage: 1,
        pageSize: 30,
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserSceneList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        this.cjList = res.data.data;
      });
    },
    getRangeList() {
      const form = {
        currentPage: 1,
        pageSize: 30,
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getFieldList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...form,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        this.rangeList = res.data.data;
      });
    },
    getRebackList() {
      if (!this.currentPageClass) {
        return;
      }
      const form = {
        currentPage: 1,
        pageSize: 30,
        school_id: this.userInfo.school_id || "",
        grade_id: this.currentPageClass.id,
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserRebackList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        // this.clList = res.data.data;

        this.clList = res.data.data.map((arr) => {
          let list = [];
          arr.childs.forEach((item) => {
            list = [...list, ...item.childs.flat()];
          });

          arr.childs = list;
          return arr;
        });
      });
    },
    getGuideList() {
      if (!this.currentPageClass) {
        return;
      }
      const form = {
        currentPage: 1,
        pageSize: 30,
        school_id: this.userInfo.school_id || "",
        grade_id: this.currentPageClass.id,
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserGuideList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        this.guideList = res.data.data.map((arr) => {
          let list = [];
          arr.childs.forEach((item) => {
            list = [...list, ...item.childs.flat()];
          });

          arr.childs = list;
          return arr;
        });
        this.selectNum2 = 0;
        console.log(this.guideList);
      });
    },
    getClassList() {
      const form = {
        currentPage: 1,
        pageSize: 100,
        teacher_id: this.userInfo.id,
        sid: this.$store.state.headers,
        school_id: this.userInfo.school_id || "",
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.allClassList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        this.classList = res.data.data;
        this.className = this.classList[0].class_name;
        this.$store.state.currentClass = this.classList[0];
        // this.getAllStudents();
        this.getGuideList();
        this.getRebackList();
      });
    },
    getAllStudents() {
      this.studentListForm = {
        class_id: this.currentClass.id,
        currentPage: 1,
        name: "",
        pageSize: 100,
        teacher_id: this.userInfo.id,
        school_id: this.userInfo.school_id || "",
      };

      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getGroupStudentList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.studentListForm,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        this.studentList = res.data.data;
      });
    },
    ...mapActions(["setBea"]),
    getObserRebackList() {
      axios({
        method: "get",
        url: directorTestApi.main + directorTestApi.getObserRebackList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
      });
    },
    getActList() {
      axios({
        method: "get",
        url: directorTestApi.main + directorTestApi.getObserActList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        params: {
          currentPage: 1,
          pageSize: 100,
          school_id: this.userInfo.school_id || "",
        },
      }).then((res) => {
        this.activityList = res.data.data;
      });
    },
    handleChangeBea(e, item) {
      this.selectBeaForm = {
        range: item.name,
      };
    },
    handleAddBea() {
      if (!this.selectBeaForm || !this.selectBeaForm.detail) {
        this.$message.error("请选择目标");
        return;
      }
      this.selectBeaForm.students = this.students;
      this.selectBeaForm.students.map((item) => {
        item.bea = _.cloneDeep(this.selectBeaForm.detail);
        return item;
      });
      this.openBea = true;
      this.showBea = false;
    },
    handleEditbeva(studentBea) {
      console.log(studentBea);
      this.selectBeaForm = {
        detail: studentBea.bea,
        students: [studentBea],
      };
    },
    handleSelectBea2(e, child) {
      this.selectBeaForm = {
        range: this.selectBeaForm.range.split(">")[0] + ">" + child.name,
        rangeId: this.selectBeaForm.rangeId || "",
        detail: child.childs.filter((item) => item.name == e.target.value)[0],
        students: this.students.map((item) => {
          item.bea = _.cloneDeep(
            child.childs.filter((item) => item.name == e.target.value)[0]
          );
        }),
      };
    },
    handleSelectBea3(e, child) {
      console.log(e);
      this.selectBeaForm.rangeId = child.id;
    },
    handleCancelAllStudents() {
      this.checkAll = false;
    },
    handleSelectAllStudents(e) {
      this.checkAll = e.target.checked;
      if (e.target.checked) {
        this.studentList.forEach((element, index) => {
          element.student.forEach((el) => {
            el.checked = true;
          });
        });
      } else {
        this.students = [];
        this.studentList.forEach((element, index) => {
          element.student.forEach((el) => {
            el.checked = false;
          });
        });
      }
      this.$forceUpdate();
    },
    //选择策略详情
    handleSelectCjDetail() {
      console.log(this.activeCl, this.clList);
      // if (this.activeCl.detail_id.length > 2) {
      //   this.$message.error("超出策略选择上限");
      //   return;
      // }
      this.showClDetail = false;
    },
    handleShowPlate() {
      if (this.formContent) {
        this.$confirm({
          title: "更换模板后，已经输入的内容不能同步保存哦",
          type: "warning",
          centered: true,
          size: "small",
          icon: "exclamation-circle",
          onOk: () => {
            this.showPlate = true;
          },
          onCancel: () => {},
        });
      } else {
        this.showPlate = true;
      }
    },
    handleAddObserve() {
      this.record_att.push({
        record_text: "",
        fileList: [],
        fileList2: [],
      });
    },
    handleAddbeva() {
      if (this.students.length < 1) {
        this.$message.error("请先选择观察对象");
        return;
      }
      this.showBea = true;
      // this.$router.push("/observe/addLevel");
    },
    handleChangePlate() {
      this.form.type = this.selectType;
      this.showPlate = false;
      this.checkedList = [];
      this.rangeCheckedList = [];
      this.cjCheckedList = [];
      this.form.id = "";
      this.beas = [];
      (this.record_att = [
        {
          record_text: "",
          fileList: [],
          fileList2: [],
        },
      ]),
        (this.analysis_att = []);
      this.guidance_att = [];
      this.students = [];
      this.form = {
        type: this.form.type,
        content: "",
        record_time: moment().format("YYYY-MM-DD HH:mm:ss"),
        strategy: "",
        act_id: "",
        record_att: [
          {
            record_text: "",
            fileList: [],
            fileList2: [],
          },
        ],
        analysis: "",
        guidance: "",
        range: [],
        status: 1,
        sync_parent: 0,
      };
      if (this.saveTimer) {
        clearInterval(this.saveTimer);
      }
      this.saveTimer = setInterval(() => {
        if (this.students.length) {
          this.handlePush("draft");
        }
      }, 10000);
    },
    handleSelectCl(item, cl) {
      this.activeCl = item;
      this.showClDetail = true;
    },
    onChange(e) {
      console.log(e);
      this.checkedList = e;
    },
    handleAddRange() {
      console.log(this.rangeCheckedList);
      this.range = this.rangeCheckedList.flat();
      this.showRange = false;
    },
    handleAddStudents() {
      this.students = this.studentList
        .map((item) => item.student)
        .flat()
        .filter((item) => item.checked);
      this.$store.state.beaStudents = this.studentList
        .map((item) => item.student)
        .flat()
        .filter((item) => item.checked);
      this.showAddStudents = false;
    },
    handleAddCj() {
      this.cj = this.cjCheckedList.flat();
      this.showAddCj = false;
      console.log(this.selef_scene_ids);
    },
    handleAddActivity() {
      this.activity = this.activityCheckedList.flat();
      this.showActivity = false;
    },
    SectionToChinese(section) {
      var chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      var chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
      var strIns = "",
        chnStr = "";
      var unitPos = 0;
      var zero = true;
      while (section > 0) {
        var v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    },
    //策略家庭确认选择
    handleConfrimCl() {
      let content = "";
      if (this.showPush == "cl") {
        let mbIndex = 1;
        this.clList.forEach((child) => {
          child.childs.forEach((item) => {
            let detailStr = "";
            item.childs.forEach((detail) => {
              if (detail.detail_id) {
                detailStr +=
                  "第" +
                  this.SectionToChinese(mbIndex) +
                  " " +
                  detail.name +
                  "\n";
                mbIndex++;
                detail.childs.forEach((item) => {
                  const label = detail.detail_id.filter((id) => item.id == id);
                  if (label.length) {
                    detailStr += item.name + "\n";
                  }
                });
              }
            });
            content += detailStr;
          });
        });
        this.form.strategy = content;
      } else {
        let mbIndex = 1;
        this.guideList.forEach((child) => {
          child.childs.forEach((item) => {
            let detailStr = "";
            item.childs.forEach((detail, index) => {
              if (detail.checked) {
                if (index == 0) {
                  detailStr +=
                    "第" +
                    this.SectionToChinese(mbIndex) +
                    " " +
                    item.name +
                    "\n";
                  mbIndex++;
                }
                detailStr += detail.name + "\n";
              }
            });
            content += detailStr;
          });
        });
        this.form.guidance = content;
      }

      this.showPush = "";
    },
    handlePush() {
      if (this.pushing) {
        this.$message.error("正在保存中，请勿重复保存");
        return;
      }
      if(this.students.length == 0){ 
        this.$message.error("无可转换的学生");
        return;
      }
      if (this.formContent || type == "draft") {
        this.pushing = true;
        this.form.student_id = this.students.map((item) => item.id).join(",");
        if (this.beas.length) {
          this.form.targets = JSON.stringify(
            this.students.map((student) => {
              const bea = this.beas.find((item) => item.id == student.id);

              return {
                student_id: student.id,
                target_id: bea.targets
                  .map((target1) => {
                    return target1.targets
                      .map((target2) => {
                        return target2.id;
                      })
                      .join(",");
                  })
                  .join(","),
              };
            })
          );
        }

        this.form.teacher_id = this.userInfo.id;
        this.school_id = this.userInfo.school_id || "";
        const act_names = this.activityCheckedList.flat();
        const act_ids = [];
        this.activityList.forEach((item) => {
          item.acts.forEach((act) => {
            if (act_names.includes(act.name)) {
              act_ids.push(act.id);
            }
          });
        });
        this.form.act_id = act_ids.join(",");

        const range_names = this.range.flat();
        const range_ids = [];
        this.rangeList.forEach((item) => {
          item.childs.forEach((range) => {
            if (range_names.includes(range.name)) {
              range_ids.push(range.id);
            }
          });
        });
        this.form.field_id = range_ids.join(",");

        const scene_names = this.cjCheckedList.flat();
        const scene_ids = [];
        this.cjList.forEach((item) => {
          item.scenes.forEach((sce) => {
            if (scene_names.includes(sce.name)) {
              scene_ids.push(sce.id);
            }
          });
        });
        this.form.scene_id = scene_ids.join(",");

        const analysis_list = [
          ...this.analysis_att1.map((item) => {
            return {
              accessory_id: item.response.data.id,
              content: "",
            };
          }),
          ...this.analysis_att2.map((item) => {
            return {
              accessory_id: item.response.data.id,
              content: "",
            };
          }),
        ];

        this.form.analysis_att = analysis_list.length
          ? JSON.stringify(analysis_list)
          : "";

        const guidance_list = [
          ...this.guidance_att1.map((item) => {
            return {
              accessory_id: item.response.data.id,
              content: "",
            };
          }),
          ...this.guidance_att2.map((item) => {
            return {
              accessory_id: item.response.data.id,
              content: "",
            };
          }),
        ];

        this.form.guidance_att = guidance_list.length
          ? JSON.stringify(guidance_list)
          : "";

        const strategy_list = [
          ...this.strategy_att1.map((item) => {
            return {
              accessory_id: item.response.data.id,
              content: "",
            };
          }),
          ...this.strategy_att2.map((item) => {
            return {
              accessory_id: item.response.data.id,
              content: "",
            };
          }),
        ];

        this.form.strategy_att = strategy_list.length
          ? JSON.stringify(strategy_list)
          : "";

        this.form.record_att = JSON.stringify(
          this.record_att.map((item) => {
            return {
              record_text: item.record_text,
              attVo:
                item.fileList.length + item.fileList2.length
                  ? [
                      ...item.fileList.map((item) => {
                        return {
                          accessory_id: item.response.data.id,
                          content: "",
                        };
                      }),
                      ...item.fileList2.map((item) => {
                        return {
                          accessory_id: item.response.data.id,
                          content: "",
                        };
                      }),
                    ]
                  : "",
            };
          })
        );
        this.form.class_id = this.currentClass.id;
        // this.form.scene_id = this.cjCheckedList.
        if (this.form.type == 1) {
          this.$message.loading({
            content: "数据转换中...",
            duration: 3,
            key: "submit",
          });
          this.school_id = this.userInfo.school_id || "";
          this.form.record_text = this.record_att[0].record_text;
          console.log(this.students, this.studentList);
          this.form.obserCircleId = this.students
            .map((item) => {
              return item.obser_circle_id;
            })
            .join(",");
          this.form.record_att =
            this.record_att[0].fileList.length +
            this.record_att[0].fileList2.length
              ? JSON.stringify([
                  ...this.record_att[0].fileList.map((item) => {
                    return {
                      accessory_id: item.response.data.id,
                      content: "",
                    };
                  }),
                  ...this.record_att[0].fileList2.map((item) => {
                    return {
                      accessory_id: item.response.data.id,
                      content: "",
                    };
                  }),
                ])
              : "";
          axios({
            method: "post",
            url:
              directorTestApi.main + directorTestApi.saveTransformObserNotable,
            headers: {
              "content-type": "application/x-www-form-urlencoded",
              Authorization: this.$store.state.headers,
            },
            data: qs.stringify(this.form),
          })
            .then((res) => {
              this.pushing = false;
              if (res.data.code == 1) {
                this.$message.success({
                  content: "转换成功",
                  key: "submit",
                });
                setTimeout(() => {
                  this.$emit("close", true);
                }, 800);
              } else {
                this.$message.error({
                  content: res.data.message,
                  key: "submit",
                });
                this.saveTime = "";
              }
            })
            .catch((error) => {
              this.pushing = false;
            });
        }
      } else {
        this.$message.error("请完善必填内容");
      }
    },
    handleUploadChange(info, key) {
      this[key] = info.fileList.map((item) => {
        if (!item.thumbUrl && item.status == "done") {
          item.thumbUrl =
            item.type.indexOf("audio") > -1
              ? require("../../assets/director/record.png")
              : require("../../assets/director/video.png");
        }
        return item;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-checkbox-group {
  width: 100%;
}
section.section {
  border-bottom: 1px solid #ececec;
  padding: 20px 0;

  .z-title {
    position: relative;
    padding-left: 10px;
    line-height: 1.2;
    font-size: 14px;
    color: #555;
    font-weight: bold;
    &::before {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      width: 3px;
      background: #73b5de;
      height: 100%;
    }
    span {
      color: red;
      margin-left: 1px;
    }
    span.tip {
      color: #999;
      font-weight: 400;
      margin-left: 5px;
    }
  }

  .input {
    margin-top: 10px;
    position: relative;
    .number {
      position: absolute;
      right: 12px;
      bottom: 3px;
      font-size: 12px;
      color: #7a7a7a;
    }
  }

  .upload {
    margin-top: 10px;
    span {
      display: inline-block;
    }
  }
  .upload-tip {
    font-size: 12px;
    color: #999;
    width: 100%;
  }

  .content {
    margin-top: 20px;
  }
}

.range {
  margin: 10px 0;
  .Up {
    font-weight: 800;
    margin-bottom: 5px;
    font-size: 14px;
  }
}

.page2 {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  .router {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    flex-direction: row;
    padding: 0 0px;
    color: #999;
    .back {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-direction: row;
      .name {
        margin-left: 5px;
        color: #999;
      }
    }
  }

  .srcoll {
    max-height: calc(100vh - 260px);
    overflow-y: auto;
    padding: 15px 2px;
    background: #fff;
    border-radius: 5px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }
  }
}

.drawer-select {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    width: 100%;
  }
}
.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    padding: 20px;
    .plate {
      margin-top: 20px;
      user-select: none;
      .item {
        font-size: 12px;
        width: 120px;
        height: 155px;
        border-radius: 5px;
        cursor: pointer;
        padding: 10px;
        margin-right: 10px;
        color: #555;
        position: relative;
        font-size: 14px;
        box-shadow: 2px 3px 6px 3px rgba($color: #0e6dc5, $alpha: 0.2);
        &::after {
          content: "";
          position: absolute;
          left: 10px;
          top: 50px;
          height: 5px;
          border-radius: 5px;
          width: 40px;
          background: #90bce6;
        }

        &::before {
          content: "";
          position: absolute;
          left: 10px;
          top: 60px;
          height: 5px;
          border-radius: 5px;
          width: 55px;
          background: #90bce6;
        }
      }
    }
  }
}

.selectCl {
  border: 1px solid #92b8cf !important;
  color: #fff !important;
  background: #7da2b9 !important;
  padding: 4px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  margin-top: 10px;
}

.bea {
  margin-top: 10px;
  .mb {
    color: #598ebe;
    font-weight: bold;
    margin: 5px 0;
  }
  .students {
    margin: 10px 0;
  }
  .bea-list {
    width: 100%;
    .cell {
      padding: 5px 10px;
      border-radius: 20px;
      border: 1px solid #eee;
      margin: 8px 0;
      box-shadow: 0 0 2px 1px rgba($color: #000000, $alpha: 0.06);
    }
  }
}

.hr {
  height: 6px;
  background: #eee;
}

.cl-card {
  width: 100%;
  box-shadow: 0 0 3px 2px rgba($color: #000000, $alpha: 0.08);
  padding: 10px;
  border-radius: 8px;
  .item {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .foot {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 0;
    font-size: 12px;

    .select {
      color: #999;
      margin-right: auto;
    }
  }
}

.clDetail {
  width: 100%;
  padding: 15px;
  .cl-title {
    font-size: 14px;
    font-weight: bold;
  }

  .cl-list {
    margin: 10px 0;
    .title {
      font-size: 12px;
      color: #999;
      padding: 10px;
    }
  }
}

.cl-list {
  margin: 10px 0;
  .title {
    font-size: 14px;
    color: #8a8a8a;
    padding: 5px 15px 5px 25px;
    font-weight: bold;
    position: relative;
    &::after {
      position: absolute;
      left: 15px;
      top: 8px;
      width: 3px;
      bottom: 8px;
      content: "";
      background: #cdcdcd;
    }
  }
}

.select-this {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    //倒三角
    width: 0;
    z-index: 20;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #90bce6 transparent;
    left: 42%;
    top: 24px;
  }
}

.ant-checkbox-wrapper {
  .wrapper2 {
    height: auto;
    position: static;
    .name {
      font-size: 14px;
      color: #333;
    }
    .content {
      color: #666;
    }
    .source {
      text-align: right;
      color: #999;
    }
  }
}
</style>
